import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import moment from 'moment';

var ServiceManager = /*#__PURE__*/_createClass(function ServiceManager(tenantServices, schoolServices) {
  var _this = this;

  _classCallCheck(this, ServiceManager);

  _defineProperty(this, "getServices", function () {
    return {
      haldorEducation: _this.haveService('HALDOR_EDUCATION'),
      haldorCoursePlanning: _this.haveService('HALDOR_COURSEPLANNING'),
      microsoft: _this.haveService('MS_ASSIGNMENTS'),
      haldor: _this.haveService('HALDOR_ASSIGNMENTS'),
      news: _this.haveService('HALDOR_NEWS'),
      schedule: _this.haveService('HALDOR_SCHEDULE'),
      advancedSchedule: _this.haveService('HALDOR_ADVANCED_CALENDAR'),
      plans: _this.haveService('HALDOR_PLANS'),
      conversations: _this.haveService('HALDOR_CONVERSATIONS'),
      attendance: _this.haveService('HALDOR_ATTENDANCE'),
      forms: _this.haveService('HALDOR_FORMS'),
      meetings: _this.haveService('HALDOR_MEETINGS'),
      verdicts: _this.haveService('HALDOR_VERDICTS'),
      additionalAdjustments: _this.haveService('HALDOR_ADDITIONAL_ADJUSTMENTS'),
      teamsMeeting: _this.haveService('HALDOR_TEAMSMEETINGS'),
      notes: _this.haveService('HALDOR_NOTES'),
      exportAssessments: _this.haveService('HALDOR_EXPORTASSESSMENTS'),
      plagiarism: _this.haveService('HALDOR_EDUCATION_PLAGIARISM'),
      immersiveReaderPlans: _this.haveService('IMMERSIVE_READER_PLANS'),
      immersiveReaderAssignments: _this.haveService('IMMERSIVE_READER_ASSIGNMENTS'),
      immersiveReaderPosts: _this.haveService('IMMERSIVE_READER_POSTS'),
      immersiveReaderConversations: _this.haveService('IMMERSIVE_READER_CONVERSATIONS')
    };
  });

  _defineProperty(this, "haveService", function (serviceId) {
    return _this.tenantServices != null && _this.tenantServices.find(function (service) {
      return service.serviceId == serviceId && moment(service.serviceEnd).isSameOrAfter(moment(), 'day');
    }) != null || _this.schoolServices != null && _this.schoolServices.find(function (service) {
      return service.serviceId == serviceId && moment(service.serviceEnd).isSameOrAfter(moment(), 'day');
    }) != null;
  });

  this.tenantServices = tenantServices;
  this.schoolServices = schoolServices;
});

export default ServiceManager;